module.exports = __webpack_public_path__ + "static/media/new-star-empty.b2bc3eca.png";